import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from "rxjs";
import { catchError, map, finalize, switchMap, filter, take } from "rxjs/operators"
import { AlertService } from './Shared/Modules/alert/alert.service';
import { ActivityPermissionService } from './Shared/Services/Activity-Permission/activity-permission.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { NgbPaginationNext } from '@ng-bootstrap/ng-bootstrap';
import { InteractionRequiredAuthError } from 'msal';
import { AppErrorType } from "./Shared/Enums";
import { LoginService } from './Shared/Services/Users/login.service';

const requestObj = {
    scopes: ['user.read', 'User.ReadBasic.All']
};

@Injectable({ providedIn: 'root' })
export class AppInterceptorService implements HttpInterceptor {
    private isRefreshing = false;
    private refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

    constructor(private alertService: AlertService,
        private activityPermissionService: ActivityPermissionService,
        private activatedRoute: ActivatedRoute,
        private authService: MsalService,
        private router: Router,
        private loginService: LoginService) { }

    handleError = (error: HttpErrorResponse, request?, next?) => {


        setTimeout(() => {
            //this.alertService.fnLoading(false);   
            let statusCode = error.status;
            let errorMsg = (error.error && error.error.msg) ? error.error.msg : "";
            if (statusCode == 0) {
                errorMsg = "You may have internet connection problem. Check your network and try again";
            } else if (statusCode == 404) {
                errorMsg = "You may have application issues. Please contact with system admin.";
            }
            else if (error.error && error.error.Type as any === AppErrorType.Alert) {
                if (error.error && error.error.Error && error.error.Error.Message) {
                    errorMsg = error.error.Error.Message;
                    this.alertService.tosterDanger(errorMsg);
                    return;
                }
            }
            else if (error.error && error.error.type as any === AppErrorType.Alert) {
                if (error.error && error.error.error && error.error.error.Message) {
                    errorMsg = error.error.error.Message;
                    this.alertService.tosterDanger(errorMsg);
                    return;
                }

            }
            else if (error.url.indexOf('graph.microsoft.com') > -1 && error.status == 401) {
                this.authService.acquireTokenSilent(requestObj).then((tokenResponse) => {
                    localStorage.setItem('adtoken', tokenResponse.accessToken);
                    window.location.reload();
                }).catch(function (error) {
                });
            }
            else if (statusCode == 401) {
                errorMsg = "You are not authorized. Please contact with system admin.";
            }
            else if (statusCode == 500) {

                this.alertService.tosterDanger("Internal server error.");
            }

            if (errorMsg != "") {
                this.alertService.titleTosterDanger(errorMsg);
            }
        }, 1000);

        return throwError(error)
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        var checkUrl = request.url.indexOf('/Notification/GetPaginateNotification');
        
        if(checkUrl !== -1){
            
        }       
        else
        this.alertService.fnLoading(true);

        // Skip token handling for refresh endpoint - it doesn't need Bearer token
        if (request.url.includes('/Login/refresh')) {
            console.log('Skipping token for refresh endpoint');
            if (request.method === 'POST') {
                this.shiftDates(request.body);
            }
            return next.handle(request).pipe(
                catchError((error: HttpErrorResponse) => {
                    console.log('Refresh endpoint error:', error);
                    return this.handleError(error, request, next);
                }),
                finalize(() => {
                    setTimeout(() => {
                        if (this.alertService.loadingFlag && checkUrl === -1) this.alertService.fnLoading(false);
                    }, 1000);
                })
            );
        }

        let token = '';

        // local storege for ad
        if (request.url.indexOf('graph.microsoft.com') > -1) {
            token = localStorage.getItem('adtoken');
        } else {
            token = localStorage.getItem('fmapptoken');
        }


        if (request.method === 'POST' || request.method === 'PUT') {
            this.shiftDates(request.body);
        }


        if (request.method == "DELETE") {
            let activityPermission = this.activityPermissionService.getActivityPermissionFromSession();
            let hasPermission = false;
            const reqUrl = window.location.href; //request.url

            if (activityPermission && activityPermission.length > 0) {
                const filterActPer = activityPermission.filter(x => reqUrl.indexOf(x.url) > -1);

                if (filterActPer && filterActPer.length > 0) {
                    if (request.method == "DELETE" && filterActPer[0].canDelete) {
                        hasPermission = true;
                    }
                }
            }

            if (!hasPermission) {
                let errorMsg = "You don't have permission to delete.";
                this.alertService.titleTosterDanger(errorMsg);
                setTimeout(() => {
                    this.alertService.fnLoading(false);
                }, 1000);
                return; //next.handle(request);
            }
        }


        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + token
        });

        const haderClone = request.clone({
            headers
        });
        return next
            .handle(haderClone)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    const refreshTokenValue = localStorage.getItem('fmapprefreshtoken');
                    
                    // Handle 401 errors - try to refresh token if we have a refresh token
                    if (error.status === 401 && 
                        !request.url.includes('/Login/') && 
                        !request.url.includes('graph.microsoft.com') &&
                        refreshTokenValue) {
                        return this.handle401Error(request, next, checkUrl);
                    }
                    
                    return this.handleError(error, request, next);
                }),
                finalize(() => {
                    setTimeout(() => {
                        if(this.alertService.loadingFlag && checkUrl === -1) this.alertService.fnLoading(false);
                    }, 1000);
                })
            )
    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler, checkUrl: number): Observable<HttpEvent<any>> {
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);

            const accessToken = localStorage.getItem('fmapptoken');
            const refreshToken = localStorage.getItem('fmapprefreshtoken');

            return this.loginService.refreshToken(accessToken, refreshToken).pipe(
                switchMap((response: any) => {
                    this.isRefreshing = false;
                    console.log('Refresh token response:', response);
                    console.log('Response data:', response.data);

                    if (response && response.data) {
                        // Handle both camelCase and PascalCase property names
                        const newAccessToken = response.data.accessToken || response.data.AccessToken;
                        const newRefreshToken = response.data.refreshToken || response.data.RefreshToken;
                        const newExpiration = response.data.accessTokenExpiration || response.data.AccessTokenExpiration;

                        if (newAccessToken && newRefreshToken) {
                            // Store new tokens
                            localStorage.setItem('fmapptoken', newAccessToken);
                            localStorage.setItem('fmapprefreshtoken', newRefreshToken);
                            localStorage.setItem('fmapptoken.expiry', newExpiration);

                            this.refreshTokenSubject.next(newAccessToken);

                            // Retry the original request with new token
                            const headers = new HttpHeaders({
                                Authorization: 'Bearer ' + newAccessToken
                            });
                            const retryRequest = request.clone({ headers });

                            // Handle retry - don't treat non-401 errors as auth failures
                            return next.handle(retryRequest).pipe(
                                catchError((retryError: HttpErrorResponse) => {
                                    // Only if retry also returns 401, then it's an auth issue
                                    if (retryError.status === 401) {
                                        localStorage.removeItem('fmapptoken');
                                        localStorage.removeItem('fmapprefreshtoken');
                                        localStorage.removeItem('fmapptoken.expiry');
                                        // Use full page reload to properly show login page
                                        window.location.href = '/login/sign-in';
                                    }
                                    // For other errors (like 500), just propagate the error, don't redirect
                                    return throwError(retryError);
                                })
                            );
                        }
                    }

                    return throwError(new Error('Token refresh failed'));
                }),
                catchError((error) => {
                    this.isRefreshing = false;
                    // Only clear tokens if the refresh endpoint itself failed
                    localStorage.removeItem('fmapptoken');
                    localStorage.removeItem('fmapprefreshtoken');
                    localStorage.removeItem('fmapptoken.expiry');
                    // Use full page reload to properly show login page
                    window.location.href = '/login/sign-in';
                    return throwError(error);
                })
            );
        } else {
            // Wait for the ongoing refresh to complete
            return this.refreshTokenSubject.pipe(
                filter(token => token !== null),
                take(1),
                switchMap(token => {
                    const headers = new HttpHeaders({
                        Authorization: 'Bearer ' + token
                    });
                    const retryRequest = request.clone({ headers });
                    return next.handle(retryRequest);
                })
            );
        }
    }

    shiftDates(body) {
        if (body === null || body === undefined) {
            return body;
        }

        if (typeof body !== 'object') {
            return body;
        }

        for (const key of Object.keys(body)) {
            const value = body[key];
            if (value instanceof Date) {
                body[key] = new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate(), value.getHours(), value.getMinutes()
                    , value.getSeconds()));
            } else if (typeof value === 'object') {
                this.shiftDates(value);
            }
        }
    }

}